const MAX_QUID_TOPICS_PER_LANDSCAPE = 10;

(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsListeningQueryTypes(
            module.exports
        );

    } else {
        RivalIQ.module('enums');

        enumsListeningQueryTypes(
            RivalIQ.enums
        );
    }

    function enumsListeningQueryTypes(exports) {

        // NOTE: should match the db table listening_query_type.
        exports.listeningQueryTypes = {
            SavedSearch: {
                id: 1
            },
            QuidTopic: {
                id: 2,
                maxTopicsPerLandscape: MAX_QUID_TOPICS_PER_LANDSCAPE
            }
        };
    }
})();
